<template>
  <div class="page-wrapper">
    <SearchNav />
    <div class="page-content">
      <div class="detail-page">
        <div class="page-nav-wrapper">
          <span @click="goHome" class="pointer nav-item">我的商城</span>
          <span @click="goOrderList" class="pointer nav-item">&nbsp;/&nbsp;订单管理</span>
          <span class="nav-item nav-active">&nbsp;/&nbsp;订单详情</span>
        </div>
        <div class="order-number">
          <span class="order-key">订单号：</span>
          <span :data-clipboard-text="shareText" @click="copyOrderNo" class="copy pointer">{{ orderSn }}</span>
        </div>
        <div class="page-order-info">
          <OrderInfoComplete
            :orderDetail="orderDetail"
            @refresh="getOrderDetail"
            @confirmOrder="confirmOrder"
            @confirmRefund="confirmRefund"
            @cancelorder="onCancelOrder"
            @bathAdd="onBathAdd"
            @openContract="openContract"
          />
        </div>
        <div class="space"></div>
        <div class="page-table">
          <div class="table-title">
            <div style="width: 480px" class="header-wrapper">
              <img
                @click="linkToStore(orderDetail)"
                class="store-img pointer"
                v-if="orderDetail.shopIcon"
                :src="orderDetail.shopIcon"
              />
              <img
                @click="linkToStore(orderDetail)"
                class="store-img pointer"
                v-else
                :src="require('@/assets/img/shop-logo.png')"
              />
              <span @click="linkToStore(orderDetail)" class="store-name pointer">
                {{ orderDetail.shopName }}&nbsp;&nbsp;&nbsp;&nbsp;{{ orderDetail.merchantEntityName }}
              </span>
              <span @click="onContactCustomerService" class="pointer store-connec">
                <img :src="require('@/assets/img/service-icon.png')" alt="" />
                联系商家
              </span>
            </div>
            <div style="width: 284px; text-align: center">单价</div>
            <div style="width: 284px; text-align: center">数量</div>
            <div style="width: 182px; text-align: center">商品总额</div>
          </div>
          <div class="table-items" v-for="(row, index) in orderDetail.orderItems">
            <div style="width: 480px" class="goods-wrapper">
              <div class="goods-wrapper-left">
                <img
                  @click="handlerItemDetailClick(row)"
                  class="goods-img pointer"
                  v-if="row.itemThumbnail && row.itemThumbnail.includes('http')"
                  :src="row.itemThumbnail"
                />
                <img
                  @click="handlerItemDetailClick(row)"
                  class="goods-img pointer"
                  v-else
                  :src="require('@/assets/img/goods-empty.png')"
                />
              </div>
              <div class="goods-wrapper-right">
                <p @click="handlerItemDetailClick(row)" class="goods-name pointer">{{ row.itemName }}</p>
                <p class="goods-guige">{{ row.itemContent.spec }}</p>
              </div>
            </div>
            <div class="goods-text" style="width: 284px">
              <div class="row-text">¥{{ price(row.realPrice) }}</div>
            </div>
            <div class="goods-text" style="width: 284px">
              <div class="row-text">
                {{ row.number }}
              </div>
            </div>
            <div class="goods-text" style="width: 182px">
              <div class="row-text">¥{{ price(row.realPrice * row.number) }}</div>
            </div>
          </div>
        </div>
        <div class="page-table-sum">
          <div class="state-row">
            <div v-if="userInfo.enterpriseVO && userInfo.enterpriseVO.stores[0]" class="state-row-left">
              {{ userInfo.enterpriseVO.stores[0].name }}
            </div>
            <div class="state-row-right">
              <span class="c3">总金额&nbsp;</span>
              <span class="highlight">¥{{ price(orderDetail.totalItemAmount) }}</span>
            </div>
          </div>
        </div>
        <div class="page-total-info">
          <div class="cpm-content">
            <div class="data-row">
              <div class="data-key">
                已选择 {{ (orderDetail.orderItems || []).length }} 种商品，数量 x
                {{ goodAmount(orderDetail.orderItems || []) }} 商品总额：
              </div>
              <div class="data-val">¥{{ price(orderDetail.totalItemAmount) }}</div>
            </div>
            <div v-if="orderDetail.discountAmount" class="data-row">
              <div class="data-key">优惠金额：</div>
              <div class="data-val">-¥{{ price(orderDetail.discountAmount) }}</div>
            </div>
            <div class="data-row">
              <div class="data-key">运费：</div>
              <div class="data-val">¥{{ price(orderDetail.shippingAmount) }}</div>
            </div>
            <div class="data-row">
              <div class="data-key">实付款：</div>
              <div class="data-val bigFont orange">¥{{ price(orderDetail.orderAmount) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Contract ref="Contract"></Contract>
  </div>
</template>

<script>
import Contract from '@/components/contract/index';
import OrderInfoComplete from './components/OrderInfoComplete';
import { priceFenToYuan } from '@/helpers/utils';
import { mapState, mapActions, mapGetters } from 'vuex';
import SearchNav from '@/components/SearchNav';
import * as api from '@/services';
export default {
  name: 'orderDetail',
  components: {
    SearchNav,
    OrderInfoComplete,
    Contract
  },
  computed: {
    ...mapGetters({
      groupChat: 'imChatService/getPcGroupChat',
      groupList: 'imChatService/getPcGroupList'
    }),
    ...mapState('USER', {
      userInfo: (state) => state.userInfo
    }),
    orderSn() {
      return this.$route.query.orderSn;
    },
    shopName() {
      return this.orderDetail.shopName;
    },
    payTimeout() {
      const { payTimeout } = this.orderDetail;
      let timeout = 0;
      if (payTimeout) {
        timeout = new Date(payTimeout.replace(/-/g, '/')) - Date.now();
      }
      return timeout < 0 ? 0 : timeout;
    }
  },
  data() {
    return {
      shareText: '',
      orderDetail: {}
    };
  },
  mounted() {
    Telescope.trackPage({
      trackId: 'zyb2bpc-page-ddy-ddxqyB2B'
    });

    this.$store.dispatch('layout/SET_FOOTER', false);
    this.getOrderDetail();
  },
  beforeDestroy() {
    this.$store.dispatch('layout/SET_FOOTER', true);
  },
  methods: {
    ...mapActions('order', ['setOrderInfo']),
    ...mapActions('cart', ['setSuccessCartIds', 'setCartFailList']),
    openContract(sn) {
      this.$refs.Contract.open(sn);
    },
    linkToStore(item) {
      this.$router.push({ path: `/store/${item.shopId}/homePage` });
    },

    handlerItemDetailClick(goods) {
      this.$router.push(`/goodsDetails/${goods.itemCode}`);
    },
    copyOrderNo() {
      if (this.copyBtn) {
        this.copyBtn.destroy();
      }
      this.copyBtn = new this.clipboard('.copy');
      this.shareText = this.orderSn;
      // eslint-disable-next-line new-cap
      this.copyBtn.on('success', () => {});
      this.copyBtn.on('error', (err) => {});
      this.$message.success('复制成功');
    },
    goodAmount(items) {
      const amount = items.reduce((total, item) => {
        return total + item.number;
      }, 0);
      return amount;
    },
    getInvoiceType(type) {
      if (type === -1) {
        return '无要求';
      } else {
        return type === 1 ? '专用发票' : '普通发票';
      }
    },
    getPayType(type) {
      return type === 0 ? '线上支付' : '对公转账';
    },
    price(val) {
      return priceFenToYuan(val);
    },
    async getOrderDetail() {
      const res = await api.order.getOrderDetail({ orderSn: this.orderSn });
      this.orderDetail = res;
      this.setOrderInfo(res);
    },
    confirmOrder() {
      this.$confirm('为了保证您的售后权益，请收到商品检查无误后再确认收货', {
        cancelButtonText: '取消',
        confirmButtonText: '确认',
        title: '确认收到货了吗？',
        cancelButtonClass: 'custom_confirm_button',
        confirmButtonClass: 'custom_confirm_button',
        alignFooter: 'right',
        type: 'warning'
      })
        .then(async () => {
          await api.order.confirmOrder({ orderSn: this.orderSn });
          this.getOrderDetail();
        })
        .catch();
    },
    confirmRefund(orderDetail) {
      this.$confirm('确认后订单将自动关闭', {
        cancelButtonText: '取消',
        confirmButtonText: '确认',
        title: '是否已确认收到卖家线下转账的退款？',
        cancelButtonClass: 'custom_confirm_button',
        confirmButtonClass: 'custom_confirm_button',
        alignFooter: 'right',
        type: 'warning'
      })
        .then(async () => {
          await api.order.confirmRefund({ orderSn: orderDetail.orderSn });
          this.getOrderDetail();
        })
        .catch();
    },
    async onBathAdd(orderDetail) {
      try {
        const res = await api.cart.batchAddCart({ orderSn: orderDetail.orderSn }, { handleError: true });
        this.setSuccessCartIds(res.addSuccessCartIds);
        this.setCartFailList(res.addCartFailList);
        if (res.addSuccessCartIds && res.addSuccessCartIds.length) {
          this.$router.push('/cart');
        } else {
          this.$message.error('加购失败，请看看其他商品吧');
        }
      } catch (error) {
        this.$message.error('加购失败，请看看其他商品吧');
      }
    },
    async onContactCustomerService() {
      const res = await api.shop.creatSession({
        storeId: this.orderDetail.merchantId
      });
      const { groupId } = res;
      this.$store.dispatch('imChatService/SET_CHAT_GID', groupId);
      this.$nextTick(() => {
        this.groupList.GroupListInit();
        this.groupChat.init();
      });
      this.$store.dispatch('imDialogService/openDialog');
    },
    onCancelOrder(orderSn) {
      Telescope.trackEvent({
        trackId: 'zyb2bpc-event-ddy-ddxqydjqxddanB2B'
      });
      this.$confirm('确定取消订单吗？', {
        confirmButtonText: '取消订单',
        cancelButtonText: '考虑一下',
        cancelButtonClass: 'custom_confirm_button',
        confirmButtonClass: 'custom_confirm_button',
        title: null,
        alignFooter: 'right',
        type: 'warning'
      })
        .then(async () => {
          await api.order.cancelOrder({ orderSn: orderSn });
          this.getOrderDetail();
        })
        .catch();
    },
    goHome() {
      this.$router.push('/personalCenter/index');
    },
    goOrderList() {
      this.$router.push('/orderList');
    }
  }
};
</script>

<style lang="scss" scoped>
.page-content {
  background-color: #f6f6f6;
}
.detail-page {
  width: 1232px;
  margin: 0 auto;
  background: #ffffff;
}
.page-wrapper {
  background-color: #f6f6f6;
  min-height: calc(100vh - 60px);
  .page-nav-wrapper {
    font-size: 12px;
    font-weight: 400;
    padding-top: 12px;

    background-color: #f6f6f6;
    padding-bottom: 24px;
    .nav-item {
      color: #333333;
      line-height: 20px;
    }
    .nav-active {
      color: #888888;
      line-height: 20px;
    }
  }
  .order-number {
    font-size: 12px;
    font-weight: 400;
    background-color: #f6f6f6;
    color: #333;
    padding-bottom: 12px;
    .order-key {
      color: #999;
    }
  }

  .space {
    height: 12px;
    background-color: #f6f6f6;

    width: 100%;
  }
  .page-table {
    border: 1px solid #dfdfdf;
    border-bottom: none;
    .table-title {
      display: flex;
      flex-direction: row;
      border-bottom: 1px solid #dfdfdf;
      height: 44px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 44px;
    }
    .header-wrapper {
      display: flex;
      align-items: center;
      padding-left: 16px;
      .store-img {
        width: 28px;
        height: 28px;
        margin-right: 8px;
      }
      .store-name {
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        margin-right: 13px;
      }
      .store-connec {
        font-size: 12px;
        font-weight: 400;
        color: #1e8dff;
        display: flex;
        align-items: center;
        img {
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }
      }
    }
    .row-text {
      text-align: center;
    }
    .table-items {
      display: flex;
      flex-direction: row;
    }
    .goods-text {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 12px;
      text-align: center;
      padding-top: 16px;
      border-bottom: 1px solid #dfdfdf;
      border-left: 1px solid #dfdfdf;
    }
    .goods-wrapper {
      display: flex;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #dfdfdf;
      .goods-wrapper-left {
        margin-right: 8px;
        .goods-img {
          width: 80px;
          height: 80px;
        }
      }
      .goods-wrapper-right {
        flex: 1;
        height: 83px;
        .goods-name {
          font-size: 12px;
          font-weight: 400;
          color: #333333;
          margin-bottom: 8px;
        }
        .goods-guige {
          font-size: 12px;
          font-weight: 400;
          color: #888888;
          margin-bottom: 16px;
        }
      }
    }
  }
  .page-table-sum {
    .state-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 36px;
      font-size: 12px;
      border: 1px solid #dfdfdf;
      padding-left: 16px;
      padding-right: 40px;
      border-top: none;
      .state-row-left {
        color: #999999;
      }
      .state-row-right {
        display: flex;
        color: #595959;
        align-items: center;
      }
      .c3 {
        color: #333;
      }
      .highlight {
        color: #d96900;
      }
    }
  }
  .page-total-info {
    margin-bottom: 40px;
    .cpm-content {
      min-height: 132px;
      background: #ffffff;
      border-top: none;
      padding-right: 40px;
      padding-top: 24px;
      font-size: 14px;
      padding-bottom: 12px;
      .data-row {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 12px;
        align-items: center;
        color: #333333;
        .data-val {
          text-align: right;
          width: 196px;
        }
        .orange {
          color: #d96900;
        }
        .bigFont {
          font-size: 24px;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
